import { z } from "zod";

export const navIndicatorEntrySchema = z
  .object({
    count: z.number().int().nonnegative(),
  })
  .strict();

export const navIndicatorsSchema = z
  .object({
    indicators: z.record(z.string(), navIndicatorEntrySchema),
  })
  .strict();

export type NavIndicators = z.infer<typeof navIndicatorsSchema>;
